import { useEffect, useRef, useState } from "react";
import { Brecha } from "../../context";

interface Props extends React.SVGProps<SVGSVGElement> {
  showText?: boolean;
  showFrontal?: boolean;
  showBarragem?: boolean;
  brecha: Brecha;
  nomeEstrutura: string;
}

export const BrechaSVG: React.FC<Props> = ({ brecha, showText, showFrontal, showBarragem, nomeEstrutura, ...svgProps }) => {
  const ref = useRef<SVGSVGElement>(null);

  const [barragemSVG, setBarragemSvg] = useState<JSX.Element>(<></>);
  const [frontSVG, setFrontSVG] = useState<JSX.Element>(<></>);
  const [textSVG, setTextSVG] = useState<JSX.Element[]>([]);

  useEffect(() => {
    if (!ref.current) return;

    const widthTotal = ref.current.clientWidth;
    const heightTotal = ref.current.clientHeight;

    const widthBarragem = widthTotal * ((showFrontal ?? true) ? (3 / 5) : 1);
    const widthFrontal = widthTotal * ((showBarragem ?? true) ? (2 / 5) : 1);

    let w = 0;
    let h = 0;

    if (showBarragem ?? true) {
      let w = 0;
      let h = 1;
      // Macico de terra
      let macicoPath = `M${w * widthBarragem} ${h * heightTotal} `;
      h -= 0.8;
      macicoPath += `L${w * widthBarragem} ${h * heightTotal} `;
      w += 0.1;
      macicoPath += `L${w * widthBarragem} ${h * heightTotal} `;
      w += 0.2;
      h += 0.7;
      macicoPath += `L${w * widthBarragem} ${h * heightTotal} `;
      w += 0.1;
      h -= 0.07;
      macicoPath += `C${w * widthBarragem} ${h * heightTotal}, `;
      w += 0.1;
      h += 0.14;
      macicoPath += `${w * widthBarragem} ${h * heightTotal} `;
      w += 0.1;
      h -= 0.07;
      macicoPath += `${w * widthBarragem} ${h * heightTotal} `;
      h += 0.10;
      macicoPath += `L${w * widthBarragem} ${h * heightTotal} `;
      w -= 0.6;
      macicoPath += `L${w * widthBarragem} ${h * heightTotal} Z`;

      // Barragem
      w = 0.55;
      h = 1;
      let barragemPath = `M${w * widthBarragem} ${h * heightTotal} `;
      w += 0.15;
      h -= 0.7;
      barragemPath += `L${w * widthBarragem} ${h * heightTotal} `;
      w += 0.1;
      barragemPath += `L${w * widthBarragem} ${h * heightTotal} `;
      w += 0.15;
      h += 0.7;
      barragemPath += `L${w * widthBarragem} ${h * heightTotal} Z`;

      // Água
      w = 0.1511;
      h = 0.40;
      let aguaPath = `M${w * widthBarragem} ${h * heightTotal} `;
      w += 0.18;
      h -= 0.07;
      aguaPath += `C${w * widthBarragem} ${h * heightTotal}, `;
      w += 0.19;
      h += 0.14;
      aguaPath += `${w * widthBarragem} ${h * heightTotal}, `;
      w += 0.179;
      h -= 0.07;
      aguaPath += `${w * widthBarragem} ${h * heightTotal} `;
      h += 0.58;
      aguaPath += `L${w * widthBarragem} ${h * heightTotal} `;
      w -= 0.549;
      aguaPath += `L${w * widthBarragem} ${h * heightTotal} Z`;

      // Brecha
      w = 0.55;
      h = 1;
      let brechaPath = `M${w * widthBarragem} ${h * heightTotal} `;
      w += 0.15;
      h -= 0.60;
      brechaPath += `L${w * widthBarragem} ${h * heightTotal} `;
      w += 0.13;
      brechaPath += `L${w * widthBarragem} ${h * heightTotal} `;
      w += 0.17;
      h += 0.6;
      brechaPath += `L${w * widthBarragem} ${h * heightTotal} Z`;


      setBarragemSvg(<>
        {/* Água */}
        <path
          d={aguaPath}
          fill="#0e9bda"
          stroke="black"
          strokeWidth="0.5"
        />

        {/* Maciço de Terra */}
        <path
          d={macicoPath}
          fill="#9e6100"
          stroke="black"
          strokeWidth="2"
        />

        {/* Barragem */}
        <path
          d={barragemPath}
          fill="#726b60"
          stroke="black"
          strokeWidth="2"
        />

        {/* Brecha */}
        <path
          d={brechaPath}
          fill="transparent"
          stroke="black"
          strokeWidth="1"
          strokeDasharray="5,5"
        />
      </>);
    }

    if (showFrontal ?? true) {
      w = widthTotal;
      h = 0.4 * heightTotal;

      // Front 1
      let barragem = `M${w} ${h} `;
      w -= widthFrontal;
      barragem += `L${w} ${h} `;
      w += (1 / 3) * widthFrontal;
      h += 0.61 * heightTotal;
      barragem += `L${w} ${h} `;
      w += (1 / 3) * widthFrontal;
      barragem += `L${w} ${h} Z`;


      // Center
      w = widthTotal - (2 / 3) * widthFrontal;
      h = 0.4 * heightTotal;
      let center = `M${w} ${h} `;
      w += (1 / 9) * widthFrontal;
      h += 0.61 * heightTotal;
      center += `L${w} ${h} `;
      w += (1 / 9) * widthFrontal;
      center += `L${w} ${h} `;
      w += (1 / 9) * widthFrontal;
      h -= 0.61 * heightTotal;
      center += `L${w} ${h} Z`;


      // Componente
      setFrontSVG(<>
        <path
          d={barragem}
          fill="#9e6100"
          stroke="black"
          strokeWidth="1"
        />
        <path
          d={center}
          fill="#793b00"
          stroke="black"
          strokeWidth="2"
        />
      </>);
    }

    // Textos
    const textSVG = [];

    // Texto Nome Estrutura
    if ((showBarragem ?? true)) {
      w = 0.74 * widthBarragem;
      h = 0.5 * heightTotal;
      textSVG.push(
        <text
          key={"nameStru"}
          x={w}
          y={h}
          textAnchor="middle"
          dominantBaseline="center"
          fill="black"
          fontSize={`${heightTotal * 0.1}`}
          fontWeight={"bold"}
        >
          {nomeEstrutura.split(" ").map((nome, i) => <tspan
            key={i}
            x={w}
            dy="1.2em">{nome}
          </tspan>)}
        </text>
      );
    }

    // Texto Brecha
    if ((showFrontal ?? true)) {
      w = widthTotal + (-1 / 2) * widthFrontal;
      h = 0.7 * heightTotal;
      textSVG.push(
        <text

          key={"nameBre"}
          x={w}
          y={h}
          textAnchor="middle"
          dominantBaseline="middle"
          fill="black"
          fontSize={`${heightTotal * 0.1}`}
          fontWeight="bold"
        >
          Brecha
        </text>
      );
    }

    if ((showText ?? true) && (showBarragem ?? true)) {
      w = 0;
      h = 0;

      // Indicardo NA Água
      w += 0.20 * widthBarragem;
      h += 0.40 * heightTotal;
      let NAPath = `M${w} ${h} `;
      h -= 0.1 * heightTotal;
      NAPath += `L${w} ${h}`;
      w += 0.1 * widthBarragem;
      NAPath += `L${w} ${h}`;
      textSVG.push(
        <path

          key={"lNA"}
          d={NAPath}
          fill="transparent"
          stroke="black"
          strokeWidth="2"
        />
      );

      // Texto NA
      w -= 0.1 * widthBarragem;
      h -= 0.015 * heightTotal;
      textSVG.push(
        <text

          key={"tNA"}
          x={w}
          y={h}
          textAnchor="start"
          dominantBaseline="bottom"
          fill="black"
          fontSize={`${heightTotal * 0.05}`}
          fontWeight={"bold"}
        >
          {"N.A. Máx. - El. " + brecha.naMax.toFixed(2).replaceAll(".", ",") + " m"}
        </text>
      );

      // Indicador Crista
      w = 0.71 * widthBarragem;
      h = 0.30 * heightTotal;
      let cotaCristaPath = `M${w} ${h} `;
      h -= 0.1 * heightTotal;
      cotaCristaPath += `L${w} ${h}`;
      w += 0.1 * widthBarragem;
      cotaCristaPath += `L${w} ${h}`;
      textSVG.push(
        <path
          key={"lCrista"}
          d={cotaCristaPath}
          fill="transparent"
          stroke="black"
          strokeWidth="2"
        />
      );

      // Texto Cota crista
      w -= 0.1 * widthBarragem;
      h -= 0.015 * heightTotal;
      textSVG.push(
        <text
          key={"tCrista"}
          x={w}
          y={h}
          textAnchor="start"
          dominantBaseline="bottom"
          fill="black"
          fontSize={`${heightTotal * 0.05}`}
          fontWeight={"bold"}
        >
          {"Crista - El. " + (brecha.elevacaoFundo + brecha.altBrecha).toFixed(2).replaceAll(".", ",") + " m"}
        </text>
      );

      // Indicador Brecha
      w = 0.75 * widthBarragem;
      h = 0.40 * heightTotal;
      let cotaBrechaPath = `M${w} ${h} `;
      h -= 0.12 * heightTotal;
      cotaBrechaPath += `L${w} ${h}`;
      w += 0.1 * widthBarragem;
      cotaBrechaPath += `L${w} ${h}`;
      textSVG.push(
        <path
          key={"lBrecha"}
          d={cotaBrechaPath}
          fill="transparent"
          stroke="black"
          strokeWidth="2"
        />
      );

      // Texto Cota crista
      w -= 0.1 * widthBarragem;
      h -= 0.015 * heightTotal;
      textSVG.push(
        <text
          key={"tCCrista"}
          x={w}
          y={h}
          textAnchor="start"
          dominantBaseline="bottom"
          fill="black"
          fontSize={`${heightTotal * 0.05}`}
          fontWeight={"bold"}
        >
          {"Crista Brecha - El. " + brecha.elevacaoTopo.toFixed(2).replaceAll(".", ",") + " m"}
        </text>
      );

      // Indicador Alt. Brecha
      w = 0.95 * widthBarragem;
      h = 1 * heightTotal;
      let altBrechaPath = `M${w} ${h} `;
      h -= 0.6 * heightTotal;
      altBrechaPath += `L${w} ${h}`;
      w -= 0.01 * widthBarragem;
      altBrechaPath += `L${w} ${h}`;
      textSVG.push(
        <path
          key={"lAltBrecha"}
          d={altBrechaPath}
          fill="transparent"
          stroke="black"
          strokeWidth="2"
        />
      );

      // Texto Alt. Brecha
      w = 0.94 * widthBarragem;
      h = 0.7 * heightTotal;
      textSVG.push(
        <text
          key={"tAltBrecha"}
          x={w}
          y={h}
          textAnchor="middle"
          dominantBaseline="middle"
          fill="black"
          fontSize={`${heightTotal * 0.05}`}
          fontWeight="bold"
          transform={`rotate(-90, ${w}, ${h})`}
        >
          {"Hb = " + brecha.altBrecha.toFixed(2).replaceAll(".", ",") + " m"}
        </text>
      );
    }

    if ((showText ?? true) && (showFrontal ?? true)) {

      // Indicardo Lar. Brecha Topo
      w = widthTotal - (2 / 3) * widthFrontal;
      h = 0.38 * heightTotal;
      let larBrechaPath = `M${w} ${h} `;
      w += (1 / 3) * widthFrontal;
      larBrechaPath += `L${w} ${h}`;
      textSVG.push(
        <path
          key={"lLarBrechaT"}
          d={larBrechaPath}
          fill="transparent"
          stroke="black"
          strokeWidth="2"
        />
      );

      // Texto Lar. Brecha Topo
      w = widthTotal - widthFrontal / 2;
      h -= 0.015 * heightTotal;
      textSVG.push(
        <text
          key={"tLarBrechaT"}
          x={w}
          y={h}
          textAnchor="middle"
          dominantBaseline="bottom"
          fill="black"
          fontSize={`${heightTotal * 0.05}`}
          fontWeight={"bold"}
        >
          {brecha.larguraTopo.toFixed(2).replaceAll(".", ",") + " m"}
        </text>
      );

      // Indicardo Lar. Brecha Baixo
      w = widthTotal + ((-1 + (1 / 3) + (1 / 9))) * widthFrontal;
      h = 0.98 * heightTotal;
      let larBrechaBPath = `M${w} ${h} `;
      w += ((1 / 9)) * widthFrontal;
      larBrechaBPath += `L${w} ${h}`;
      textSVG.push(
        <path
          key={"lLarBrechaF"}
          d={larBrechaBPath}
          fill="transparent"
          stroke="black"
          strokeWidth="2"
        />
      );

      // Texto Lar. Brecha
      w -= ((1 / 9) - (1 / 18)) * widthFrontal;
      h -= 0.015 * heightTotal;
      textSVG.push(
        <text
          key={"tLarBrechaF"}
          x={w}
          y={h}
          textAnchor="middle"
          dominantBaseline="bottom"
          fill="black"
          fontSize={`${heightTotal * 0.05}`}
          fontWeight={"bold"}
        >
          {brecha.larguraTopo.toFixed(2).replaceAll(".", ",") + " m"}
        </text>
      );

      // Indicardo Lar. Brecha Baixo
      w = widthTotal - ((1 / 3) - (0.05)) * widthFrontal;
      h = 1 * heightTotal;
      let altBrechaPath = `M${w} ${h} `;
      h -= 0.6 * heightTotal;
      altBrechaPath += `L${w} ${h}`;
      textSVG.push(
        <path
          key={"lLarBrechaB"}
          d={altBrechaPath}
          fill="transparent"
          stroke="black"
          strokeWidth="2"
        />
      );

      // Texto Lar. Brecha Baixo
      w -= 0.01 * widthFrontal;
      h += 0.3 * heightTotal;
      textSVG.push(
        <text
          key={"tLarBrechaB"}
          x={w}
          y={h}
          textAnchor="middle"
          dominantBaseline="bottom"
          fill="black"
          fontSize={`${heightTotal * 0.05}`}
          fontWeight="bold"
          transform={`rotate(-90, ${w}, ${h})`}
        >
          {brecha.larguraBase.toFixed(2).replaceAll(".", ",") + " m"}
        </text>
      );
    }

    setTextSVG(textSVG);
  }, [ref]);

  return <svg ref={ref} {...svgProps}>
    {/* Fundo */}
    <rect width="100%" height="100%" fill="#ffffdf" />

    {barragemSVG}
    {frontSVG}
    {textSVG}
  </svg>;
};